<!--
v-dialog
  persistant：モーダルにする（外枠をクリックしても閉じない）
  no-click-animation：モーダル時に外枠をクリックすると出るダイアログが揺れるアニメーションを消す
 -->
<template>
  <v-dialog
    v-model="isVisible"
    content-class="sm__dialog"
    persistent
    no-click-animation
    max-width="640px"
  >
    <v-card class="px-0 py-6 sm__card">
      <v-img
        v-if="src"
        class="px-6"
        :alt="alt"
        :src="src"
      />
      <v-card-title
        v-if="titleText"
        :class="src?'py-4':'pt-0 pb-4'"
      >
        <div class="d-flex">
          <div
            class="pr-2"
            v-if="icon"
          >
            <v-icon
              :icon="icon.name"
              :color="icon.color"
            />
          </div>
          <div>
            <sm-text
              format="sm__title"
              :text="titleText"
            />
          </div>
        </div>
      </v-card-title>

      <v-card-text
        v-if="bodyText"
        class="pt-0 pb-4"
      >
        <sm-text
          class="sm__dialog-body"
          :text="bodyText"
        />
      </v-card-text>
      <div
        class="mx-6 mb-2"
        v-if="radioOptions"
      >
        <sm-radio-inverse
          :options="radioOptions"
          v-model="_selectedOption"
        />
      </div>
      <v-card-actions
        v-if="firstBtnLabel || secondBtnLabel"
        class="px-6 py-0"
      >
        <v-spacer />
        <sm-btn-text
          v-if="firstBtnLabel"
          class="sm__dialog-btn"
          :text="firstBtnLabel"
          @click-btn="$emit('click-first-btn')"
        />
        <sm-btn-text
          v-if="secondBtnLabel && !isSecondBtnSecondary"
          class="sm__dialog-btn"
          :text="secondBtnLabel"
          @click-btn="$emit('click-second-btn')"
        />
        <sm-btn-contained
          v-if="secondBtnLabel && isSecondBtnSecondary"
          class="sm__dialog-second-btn"
          :text="secondBtnLabel"
          @click-btn="$emit('click-second-btn')"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator'
import { defineAsyncComponent, PropType } from 'vue'

@Component({
  components: {
    SmText: defineAsyncComponent(() => import('@/components/atoms/SmText.vue')),
    SmBtnContained: defineAsyncComponent(() => import('@/components/atoms/SmBtnContained.vue')),
    SmBtnText: defineAsyncComponent(() => import('@/components/atoms/SmBtnText.vue')),

    SmRadioInverse: defineAsyncComponent(() => import('@/components/molecules/SmRadioInverse.vue')),
  },
  emits: ['click-first-btn', 'click-second-btn', 'update:modelValue', 'change']
})
export default class SmDialog extends Vue {
  @Prop({ type: String })
  private readonly alt?: string

  @Prop({ type: String })
  private readonly src?: string

  @Prop({ type: String })
  private readonly bodyText?: string

  @Prop({ type: String })
  private readonly firstBtnLabel?: string

  @Prop({ type: String })
  private readonly secondBtnLabel?: string

  @Prop({ type: Boolean })
  private readonly isSecondBtnSecondary?: boolean

  @Prop({ type: String })
  private readonly titleText?: string

  @Prop({ type: Number })
  private readonly selectedOption?: number

  @Prop({
    type: Array as PropType<{
    label: string
    caption?: string
    value: string | number
  }[]>
  })
  private readonly radioOptions?:{
    label: string
    caption?: string
    value: string | number
  }[]

  @Prop({ type: Object as PropType<{name:string, color:string}> })
  private readonly icon?: {name:string, color:string}

  @Prop({ type: Boolean, required: true })
  private modelValue!: boolean

  private get isVisible(): boolean { return this.modelValue }
  private set isVisible(newValue: boolean) {
    this.$emit('update:modelValue', newValue)
  }

  private get _selectedOption(): number | undefined { return this.selectedOption }
  private set _selectedOption(newValue: number | undefined) {
    this.$emit('change', newValue)
  }
}
</script>

<style scoped>
.sm__dialog > .sm__card {
  border-radius: 16px;
  box-shadow: 0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2);
}
.sm__dialog-body.sm__dialog-body {
  color: #000000;
}
.sm__dialog-btn.v-btn { /** v-btnのデフォルトmin-width削除 */
  min-width: 0;
}
.sm__dialog-btn.v-btn.v-btn + .v-btn {  /** v-btnのデフォルトmargin変更 */
  margin-left: 16px;
}
.sm__dialog-second-btn.v-btn {
  color: #FFFFFF!important;
  background-color: #0073A3;
}
:deep(.v-card-actions){
  min-height: 0;
}
</style>
